export default __webpack_public_path__ + "static/media/obsessions.a0df9719.png";